import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a9f8641&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6a9f8641&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=6a9f8641&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f8641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9f8641')) {
      api.createRecord('6a9f8641', component.options)
    } else {
      api.reload('6a9f8641', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a9f8641&scoped=true", function () {
      api.rerender('6a9f8641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/table/ikColumn/IkColumnText/index.vue"
export default component.exports